// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".section-box .section-content[data-v-69b0b76a] {\n  width: 94%;\n  margin: 0 auto;\n  padding-top: 18px;\n  padding-bottom: 18px;\n}\n.section-box .sub-title[data-v-69b0b76a] {\n  font-size: 16px;\n  font-weight: bold;\n  color: #333333;\n  padding-bottom: 13px;\n}\n.section-box .cell p[data-v-69b0b76a] {\n  margin-bottom: 0;\n}\n.section-box .section-line[data-v-69b0b76a] {\n  height: 12px;\n  background: #F5F5FA;\n}", ""]);
// Exports
module.exports = exports;
